import axios from "axios";

const API_BASE_SRC = process.env.VUE_APP_API_BASE_SRC || "";

const om = {
  /**
   * Realizar request genérica a la API
   * @param {Object} payload payload para el endpoint
   */
  request({ endPoint, payload }) {
    // Siempre retornar la promesa de axios
    const body = payload ? JSON.parse(JSON.stringify(payload)) : payload;
    return axios.post(`${API_BASE_SRC}/${endPoint}`, body);
  },
  getRequest(endPoint) {
    // Siempre retornar la promesa de axios
    return axios.get(`${API_BASE_SRC}/${endPoint}`);
  }
};

export default om;
